'use client';

import { c as _c } from "react/compiler-runtime";
import { Suspense } from 'react';
import { QueryErrorResetBoundary } from '@tanstack/react-query';
import { ErrorBoundary } from 'react-error-boundary';
import { Body } from '../typography/Body';
import { Button } from './Button';
import { FlexContainer } from './FlexContainer';
import { SheetSkeleton } from './SheetSkeleton';
import type { ErrorInfo, ReactNode } from 'react';
import type { FallbackProps } from 'react-error-boundary';
export interface SheetSuspenseProps {
  children: ReactNode;
  entityName?: string;
  fallback?: ReactNode;
  errorFallback?: (props: FallbackProps) => ReactNode;
  open?: boolean;
  onError?: (error: unknown, info: ErrorInfo) => void;
}
interface DefaultSheetErrorProps extends FallbackProps {
  entityName?: string;
}
function DefaultSheetError(t0) {
  const $ = _c(7);
  const {
    entityName,
    resetErrorBoundary
  } = t0;
  const t1 = entityName ?? "details";
  let t2;
  if ($[0] !== t1) {
    t2 = <Body>Unable to load {t1}. Please try again.</Body>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== resetErrorBoundary) {
    t3 = <Button onClick={resetErrorBoundary} size="sm" variant="secondary">Try again</Button>;
    $[2] = resetErrorBoundary;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <FlexContainer className="gap-3" direction="column" items="start">{t2}{t3}</FlexContainer>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}
export function SheetSuspense(t0) {
  const $ = _c(7);
  const {
    children,
    entityName,
    fallback,
    errorFallback,
    open,
    onError
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== entityName || $[2] !== errorFallback || $[3] !== fallback || $[4] !== onError || $[5] !== open) {
    t1 = <QueryErrorResetBoundary>{t2 => {
        const {
          reset
        } = t2;
        return <ErrorBoundary fallbackRender={errorFallback ?? (props => <DefaultSheetError {...props} entityName={entityName} />)} onError={onError} onReset={reset} resetKeys={[open]}><Suspense fallback={fallback ?? <SheetSkeleton />}>{open === false ? null : children}</Suspense></ErrorBoundary>;
      }}</QueryErrorResetBoundary>;
    $[0] = children;
    $[1] = entityName;
    $[2] = errorFallback;
    $[3] = fallback;
    $[4] = onError;
    $[5] = open;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
}